// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__17yIW","buttons":"PendingPaymentAlert_buttons__3RahA"};